import React from "react";
import QuillEditor from "./quill-editor.jsx";
import Codemirror from "react-codemirror";
import "codemirror/mode/htmlmixed/htmlmixed";

class HtmlEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rawMode: false
    };
  }

  getStyles() {
    return {
      quillEditor: {
        minHeight: 150
      },
      quillEditorTip: {
        color: "rgb(158, 158, 158)"
      },
      switcherWrapper: {
        marginTop: -18,
        textAlign: "right"
      },
      editorSwitcher: {
        color: "rgba(33, 33, 33, 0.498039)",
        textDecoration: "underline",
        fontSize: 12,
        cursor: "pointer"
      }
    };
  }

  render() {
    let { rawMode } = this.state,
      { value, onChange } = this.props,
      styles = this.getStyles();

    return (
      <div>
        <div style={styles.switcherWrapper}>
          <span
            style={styles.editorSwitcher}
            onTouchTap={() => this.setState({ rawMode: !rawMode })}
          >
            Switch to {rawMode ? "visual" : "raw"} editor
          </span>
        </div>
        {rawMode ? (
          <Codemirror
            style={{ border: "1px solid #ccc" }}
            value={value}
            onChange={onChange}
            options={{
              lineWrapping: true,
              lineNumbers: true,
              mode: { name: "htmlmixed" }
            }}
          />
        ) : (
          <QuillEditor
            style={styles.quillEditor}
            tipStyle={styles.quillEditorTip}
            value={value}
            onChange={onChange}
          />
        )}
      </div>
    );
  }
}

export default HtmlEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/html-editor.jsx